/* ===== game/render-chunks.ts — 타일 청크 캐시를 게임 세계에 잇는다(engine render/chunkcache) ===== */
import { mixin } from '../../engine/core/mixin.js';
import { ChunkCache } from '../../engine/render/chunkcache.js';
import { dimsOf } from '../size.js';
import { TS } from '../world.js';
import { TileArt } from '../tileart.js';
import { Game } from '../game.js';
/* ★ 청크에 굽는 칸은 tileDyn 이 아닌 칸뿐이고, 굽는 그림은 칸마다 그리는 것과 같은 tileCell 이다 — 둘 중 하나만 고치면 청크 쪽만 달라 보인다.
   서명은 타일 · 벽지 · 지표 아래 첫 칸 여부(윗면 빛) — 그림이 이 셋 말고 다른 것을 보게 되면 서명에 더할 것. 사연: docs/code-history.md#h247 */

export const RenderChunks: Bag = {
  /** 이번 프레임의 청크 캐시를 준비한다 — 끈 설정(chunks false)이면 null(칸마다 그린다) */
  tileChunks(f: any, ashF: number, ashOn: boolean) {
    if (this.settings && this.settings.chunks === false) return null;
    const w = this.world;
    if (!this._cc || this._ccWorld !== w) {
      const { WW, WH } = dimsOf(w);
      let paintAsh = 0;
      this._ccWorld = w;
      this._cc = new ChunkCache({
        cell: TS, size: 16,
        sig: (x, y) => {
          if (x < 0 || y < 0 || x >= WW || y >= WH) return -1;
          const k = y * WW + x;   // 배열은 그때그때 읽는다(불러오기가 갈아 끼운다)
          return w.tiles[k] | (w.walls[k] << 10) | (y - 1 <= w.surface[x] ? 1 << 20 : 0);
        },
        paint: (g, x0, y0, x1, y1) => {
          const VA = TileArt.V, tiles = w.tiles, walls = w.walls;
          for (let y = Math.max(0, y0); y <= Math.min(WH - 1, y1); y++) for (let x = Math.max(0, x0); x <= Math.min(WW - 1, x1); x++) {
            const k = y * WW + x, id = tiles[k];
            if (this.tileDyn(w, id, k, WW)) continue;
            this.tileCell(g, w, id, walls[k], k, x, y, (x - x0) * TS, (y - y0) * TS, WW, VA, paintAsh);
          }
        }
      });
      this._ccAsh = (a: number) => { paintAsh = a; };
    }
    /* 잿빛은 1/64 걸음으로 굽는다 — 장이 넘어가는 동안만 바뀌고, 걸음마다 보이는 청크를 다시 굽는다 */
    const aq = ashOn ? Math.max(1, Math.round(ashF * 64)) : 0;
    this._ccAsh(aq / 64);
    this._cc.prepare(f.tx0, f.ty0, f.tx1, f.ty1, (TileArt.ver || 0) + '|' + aq, this.time || 0, w.stamp | 0);
    this._cc.blit(f.c, f.tx0, f.ty0, f.tx1, f.ty1, f.camX, f.camY);
    return this._cc;
  },
};
mixin(Game.prototype, RenderChunks, true);
